module.exports = __webpack_public_path__ + "static/media/happy.cdee949d.svg";